module.exports = function getResource(label, vars = []) {
    let resources = {
        pausePlayAnimationLabel: `${vars[0] ? 'Pause': 'Play'} animation`,
        previous: 'Previous',
        next: 'Next'
    };

    return resources[label];
};
